import { useEffect } from "react";
import { useLocation } from "react-router";
const useFooterUpdate = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    setTimeout(
      () => document.dispatchEvent(new Event("updateFooterVisibility")),
      1500
    );
  }, [pathname]);
};
export {
  useFooterUpdate
};
